import React, { useState } from "react";
import * as styles from "./base.scss";
import connect from "Shared/connect";
import Modal from "Shared/Modal";
import EmvProductDetail from "../../../Checkout/FullCart/ProductList/EmvProductDetail";
import { getProductDetails } from "../../../Checkout/action-creators";
import Spinner from "Shared/Spinner";
import classnames from "classnames";
import { addEcommerceEventToDataLayer, getGa4ItemListReferrel, setGa4ItemListReferrel } from "./../../../TrackingInformation";
const ProductPreview = ({ product, getProductDetails, selectedVariant, className, children, selectItemEventList, }) => {
    const [isLoading, setLoading] = useState(false);
    const [productDetailModal, setProductDetailModal] = useState(false);
    const [productDetails, setProductDetails] = useState();
    const sendGa4SelectItemEvent = () => {
        if (!!selectedVariant &&
            !!selectItemEventList &&
            selectedVariant.code in selectItemEventList) {
            const selectItemEvent = selectItemEventList[selectedVariant.code];
            setGa4ItemListReferrel(selectItemEvent.ecommerce.item_list_id);
            addEcommerceEventToDataLayer(selectItemEvent);
        }
    };
    const sendGa4ViewItemEvent = (productViewModel) => {
        // if no ga4itemlistreferrel
        var pageTypeReferrel = getGa4ItemListReferrel();
        if (!!productViewModel &&
            !!productViewModel.trackingData &&
            !!productViewModel.trackingData.ga4EventObjects &&
            "view_item" in productViewModel.trackingData.ga4EventObjects &&
            !!pageTypeReferrel) {
            const events = productViewModel.trackingData.ga4EventObjects[String("view_item")];
            const event = events[selectedVariant.code];
            event.ecommerce.items[0].item_list_id = pageTypeReferrel;
            event.ecommerce.items[0].item_list_name = pageTypeReferrel;
            addEcommerceEventToDataLayer(event);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("a", { className: classnames(styles.preview, className), onClick: () => {
                setLoading(true);
                sendGa4SelectItemEvent();
                getProductDetails(product.url.toString())
                    .then((r) => {
                    setProductDetails(r);
                    sendGa4ViewItemEvent(r);
                })
                    .then(() => setProductDetailModal(true))
                    .then(() => setLoading(false));
            } },
            children,
            !!isLoading && React.createElement(Spinner, { className: styles.spinner })),
        React.createElement(Modal, { isOpen: productDetailModal, onClose: () => setProductDetailModal(false) },
            React.createElement(EmvProductDetail, { productViewModel: productDetails, selectedVariant: selectedVariant }))));
};
export default connect((state) => ({
    selectItemEventList: state.currentPage &&
        state.currentPage.trackingData &&
        state.currentPage.trackingData.ga4EventObjects &&
        state.currentPage.trackingData.ga4EventObjects["select_item"],
}), (dispatch) => ({
    getProductDetails(url) {
        return dispatch(getProductDetails(url));
    },
}))(ProductPreview);
